import React from 'react';
import Navbar from '../components/Navbar';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQS = [
  {
    cat: '🎾 תחרויות והרשמה',
    items: [
      { q: 'איך נרשמים לתחרות?', a: 'נכנסים לעמוד התחרויות (יומיות או נוקאאוט), בוחרים תחרות פתוחה ולוחצים על כפתור ההרשמה. צריך להיות מחוברים עם משתמש רשום. אם התחרות מלאה — תיכנסו לרשימת ההמתנה ותקבלו הודעה אם יתפנה מקום.' },
      { q: 'מה ההבדל בין תחרות יומית לנוקאאוט?', a: 'תחרות יומית מתקיימת ביום אחד בשיטת בתים — כל שחקן מובטח לו מספר משחקים. תחרות נוקאאוט נמשכת לאורך תקופה בשיטת המפסיד יוצא, עם ברקט מלא עד הגמר.' },
      { q: 'מה מדיניות הביטולים?', a: 'ניתן לבטל הרשמה בחינם עד 72 שעות לפני התחרות. ביטול מאוחר יותר כרוך בדמי ביטול. שחקן עם חוב דמי ביטול לא יוכל להירשם לתחרויות עד הסדרת התשלום מול ההנהלה.' },
      { q: 'איך נרשמים לתחרות זוגות?', a: 'בעת ההרשמה לתחרות זוגות תתבקשו להזין את שם השותף/ה. הזוג נרשם יחד ומופיע יחד ברשימת המשתתפים.' },
    ],
  },
  {
    cat: '🏆 דירוג ונקודות',
    items: [
      { q: 'איך עובד הדירוג באתר?', a: 'כל ניצחון בתחרויות מזכה בנקודות לפי שלב התחרות והפורמט. הנקודות מצטברות לדירוג הכללי שמוצג בעמוד הדירוגים. פירוט מלא בעמוד "שיטת הנקודות".' },
      { q: 'מהן רמות השחקנים (דרגים)?', a: 'השחקנים מחולקים לדרגים (א, ב, ג) לפי רמת המשחק, כדי שכל אחד יתחרה מול שחקנים ברמתו. פירוט הרמות בעמוד "רמות שחקנים".' },
      { q: 'איך אני צובר תגים והישגים?', a: 'תגים מוענקים אוטומטית על הישגים: זכיות בתחרויות, רצפים של ניצחונות, השתתפות עקבית ועוד. התגים מוצגים בפרופיל האישי שלכם.' },
    ],
  },
  {
    cat: '🛒 לוח ציוד וקהילה',
    items: [
      { q: 'איך מפרסמים מודעה בלוח הציוד?', a: 'נכנסים ללוח הציוד, לוחצים "פרסם מודעה", ממלאים פרטים ומעלים עד 5 תמונות. קונים יוצרים איתכם קשר דרך הצ׳אט באתר או בוואטסאפ. כשהפריט נמכר — סמנו "נמכר".' },
      { q: 'איך מוצאים פרטנר למשחק?', a: 'בלוח "חיפוש פרטנרים" מפרסמים מודעה עם הרמה, האזור והזמן המועדף — או מגיבים למודעה קיימת דרך הצ׳אט.' },
      { q: 'איך עובד הצ׳אט באתר?', a: 'לחיצה על כפתור ההודעות פותחת את המסנג׳ר. אפשר לשלוח טקסט, תמונות והודעות קוליות, לראות מי מחובר ולקבל התראות על הודעות חדשות.' },
      { q: 'איך מקבלים התראות על ציוד חדש?', a: 'בלוח הציוד לוחצים על "התראות ציוד", בוחרים קטגוריות מעניינות — ותקבלו התראה ברגע שמתפרסמת מודעה מתאימה.' },
    ],
  },
  {
    cat: '⚙️ חשבון וטכני',
    items: [
      { q: 'איך מתקינים את האפליקציה בטלפון?', a: 'האתר עובד כאפליקציה (PWA): באייפון — פתחו בספארי, לחצו על כפתור השיתוף ואז "הוסף למסך הבית". באנדרואיד — כרום יציע התקנה אוטומטית או דרך תפריט הדפדפן.' },
      { q: 'לא מקבל התראות — מה עושים?', a: 'ודאו שאישרתם התראות בדפדפן/בטלפון עבור האתר. באייפון חובה שהאפליקציה תהיה מותקנת במסך הבית כדי לקבל התראות פוש.' },
      { q: 'איך מעדכנים תמונת פרופיל ופרטים?', a: 'נכנסים לפרופיל האישי דרך התפריט ולוחצים על עריכה. שם מעדכנים תמונה, עיר, רמה ופרטי קשר.' },
      { q: 'איך יוצרים קשר עם ההנהלה?', a: 'דרך קבוצות הוואטסאפ של הקהילה (הקישורים בעמוד הבית) או בצ׳אט הפנימי מול האדמין.' },
    ],
  },
];

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50/40 to-white dark:from-slate-900 dark:to-slate-950" dir="rtl" data-testid="faq-page">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 py-10">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 rounded-full px-4 py-1.5 text-sm font-bold mb-3">
            <HelpCircle className="w-4 h-4" />
            כל התשובות במקום אחד
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-gray-900 dark:text-white mb-2">❓ שאלות נפוצות</h1>
          <p className="text-gray-500">לא מצאתם תשובה? כתבו לנו בוואטסאפ או בצ׳אט</p>
        </div>

        {FAQS.map((section) => (
          <div key={section.cat} className="mb-8">
            <h2 className="text-lg font-black text-gray-800 dark:text-gray-100 mb-3">{section.cat}</h2>
            <Accordion type="single" collapsible className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-100 dark:border-slate-800 px-4 shadow-sm">
              {section.items.map((f, i) => (
                <AccordionItem key={i} value={`${section.cat}-${i}`} className="border-slate-100 dark:border-slate-800">
                  <AccordionTrigger className="text-right font-bold text-gray-800 dark:text-gray-100 hover:no-underline" data-testid={`faq-q-${section.cat}-${i}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 dark:text-gray-300 leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </div>
  );
}
